module.exports = __webpack_public_path__ + "static/media/banner-bg-3.40a187bb.jpg";